module.exports = __webpack_public_path__ + "img/duplicate-an-order.7cdcc229.svg";